import { ErrorCodes, FunctionGroup } from "../types/app.enums";
// import * as validations from "./validations";
/* eslint-disable camelcase */

import {
  Measures,
  Param,
  PeerGroups,
  Root,
  ServerResponse,
  ResponseMeasures,
  BatchEntry,
  AttributeResponseObject,
} from "../types/app.interfaces";
import { webRequest } from "./common";
import { activeSheetProps } from "./officedocumenthelper";
import { getActiveSheetStatebyId, setActiveSheetState } from "./sheetoptions";

let measuresArray: Measures[] = [];
let peerGroupArray: PeerGroups[] = [];
export let _batchInv: BatchEntry[] = [];
export let _isInvestBatchedRequestScheduled = false;

export function setbatchInv(value: BatchEntry[]) {
  _batchInv = value;
}

export function setIsInvestBatchedRequestScheduled(value: boolean) {
  _isInvestBatchedRequestScheduled = value;
}

function pause(ms: number) {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

function createBatchingBasedOnApiGroup(records: any) {
  const groupedRecords: any = records.reduce((groupObj: any, record: any) => {
    const key = record.functionGroup;
    if (!groupObj[key]) {
      groupObj[key] = [];
    }
    groupObj[key].push(record);
    return groupObj;
  }, {});

  const result = Object.values(groupedRecords).reduce((groupObj: any, group: any) => {
    groupObj.push(group);
    return groupObj;
  }, []);

  return result;
}

// export function _makeRemoteRequest(token: any, profileId: any) {
//   // Copy the shared batch and allow the building of a new batch while you are waiting for a response.
//   // Note the use of "splice" rather than "slice", which will modify the original _batch array
//   // to empty it out.
//   setIsInvestBatchedRequestScheduled(false);
//   const batchSize = 500;
//   const len = Math.ceil(_batchInv.length / batchSize);

//   (async () => {
//     for (let i = 0; i < len; i++) {
//       const batchArray: any = createBatchingBasedOnApiGroup(_batchInv.splice(0, batchSize));
//       await Promise.all(
//         batchArray.map(async (batch) => {
//           const apiUrl = batch[0].apiUrl;
//           const functionGroup = batch[0].functionGroup;
//           measuresArray = [];
//           peerGroupArray = [];

//           // Build a simpler request batch that only contains the arguments for each invocation.
//           const requestBatch = batch.map((item) => {
//             const measures = item.args;
//             if (functionGroup === FunctionGroup.PercentileRank) {
//               peerGroupArray.push(measures);
//             } else {
//               measuresArray.push(measures);
//             }
//             return { operation: item.operation, args: measures };
//           });

//           const parameters: Param = {
//             measures: measuresArray,
//             peerGroups: peerGroupArray,
//             dpsid_data_area_type: null,
//             dpsid_all_portfolios: false,
//             dpsid_portfolio_id: "-1", //localStorage.getItem('portfolioId').toString(),
//             dpsid_selection_set_id: null,
//             userGUID: null,
//             includeCommitment: false,
//             initialLoad: false,
//             correlationId: "34bc67f8-568d-42c7-add8-b335d3b45ea4",
//             culture: {
//               currencyDecimalSeparator: ".",
//               currencyGroupSeparator: ",",
//               name: "en-US",
//               shortDatePattern: "M/d/yyyy",
//             },
//             excelFileName: "Book2 - Excel",
//             excelSheetName: "Sheet1", //validations.getActiveWorksheet(),
//             jobTaskId: "adea50c2-7232-4401-99b1-de0394e97955",
//             sourceVersion:
//               "Microsoft.O365ProPlusRetail|x64|16.0.17425.20236|16.0.17425.20236|v1.32.1|Book2 - Excel|Sheet1",
//           };
//           const jsonRequest: Root = { parameters };
//           const functionGroupMap = {
//             [FunctionGroup.BenchmarkRank]: _fetchBenchmarkRankFromRemoteService,
//             [FunctionGroup.Getattributes]: _fetchAttributeFromRemoteService,
//             [FunctionGroup.Cfar]: _fetchCfarFromRemoteService,
//             [FunctionGroup.Holdings]: _fetchHoldingsFromRemoteService,
//             [FunctionGroup.Pooledbenchmark]: _fetchPooledbenchmarkFromRemoteService,
//             [FunctionGroup.Pooledbenchmarkphase2]: _fetchPooledbenchmarkphase2FromRemoteService,
//           };
//           try {
//             const response = await webRequest(jsonRequest, apiUrl, token, profileId);
//             const fetchService = functionGroupMap[functionGroup];

//             if (fetchService) {
//               const responseBatch = await fetchService(requestBatch, response);
//               responseBatch.forEach((res, index) => {
//                 if (res.error) {
//                   batch[index].reject(new Error(res.error));
//                 } else {
//                   batch[index].resolve(res.result);
//                 }
//               });
//             } else {
//               console.error("Unknown function group:", functionGroup);
//             }
//           } catch (error) {
//             console.error("Request failed:", error);
//           }
//         })
//       );
//     }
//   })();
// }

//CFar, Peer group, Get Attributes
async function _fetchBenchmarkRankFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseMeasuresArray: ResponseMeasures[] = resresult.map((response) => ({
        fundId: response.fundId,
        measureValue: response.measureValue == "-1" ? response.exceptionMessage : response.measureValue,
        investmentId: response.investmentId,
        measure: response.measure,
        idType: response.idType,
        portId: response.portfolioID,
        assetId: "",
        calcStartDate: response.calcStartDate,
        calcEndDate: response.calcEndDate,
        statusCode: response.statusCode,
        message: response.message,
        exceptionMessage: response.exceptionMessage,
        percentRank: response.percentRank,
        alias: response.alias,
      }));

      const resout = responseMeasuresArray.find(
        (resres) =>
          //resres.investmentId === args.investmentID &&
          //resres.measure.toUpperCase() === args.measure.toUpperCase() &&
          //args.measure != null &&
          resres.alias === args.alias
      );

      let out: any;
      if (!resout) {
        out = "#NOTFOUND - No investments found";
      } else {
        switch (resout.statusCode) {
          case ErrorCodes.Success:
            out = resout.measureValue;
            break;
          case ErrorCodes.InternalServerError:
          case ErrorCodes.UnAuthorized:
          case ErrorCodes.NotFound:
            out = resout.message + " - " + resout.exceptionMessage;
            break;
          default:
            out = "#NOTFOUND - No investments found";
            break;
        }
      }

      return { result: out };
    } catch (error) {
      return { error: `Operation failed: ${operation}` };
    }
  });
}
async function _fetchAttributeFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseAttributeArray: AttributeResponseObject[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseResult: AttributeResponseObject = {
          fundId: responseObject[_i].investmentId,
          attributeName: responseObject[_i].attributeName,
          attributeValue: convertType(
            responseObject[_i].attributeValue,
            responseObject[_i].attributeType.toLowerCase()
          ),
          investmentId: responseObject[_i].investmentId,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          alias: responseObject[_i].alias,
        };
        responseAttributeArray.push(responseResult);
      }
      const responseString = JSON.stringify(
        responseAttributeArray.find(
          (resres) =>
            //resres.investmentId === "" + args.investmentID + "" &&
            //resres.attributeName === "" + args.attributeName + "" &&
            resres.alias === args.alias
        )
      );

      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (responseObject.statusCode) {
        case ErrorCodes.Success:
          out = responseObject.attributeValue;
          break;
        case ErrorCodes.InternalServerError:
        case ErrorCodes.UnAuthorized:
        case ErrorCodes.NotFound:
          out = responseObject.message + " - " + responseObject.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchCfarFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request, index): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          investmentId: responseObject[_i].investmentId,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }

      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //resres.investmentId === "" + args.investmentID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          if (requestBatch[index].operation.toUpperCase() == "BurgissVALUATIONDATE".toUpperCase()) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcEndDate != null || resout.calcEndDate != ""
                ? new Date(resout.calcEndDate).toLocaleDateString()
                : "";
          } else {
            out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          }
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchHoldingsFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);
  return requestBatch.map((request, index): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          investmentId: responseObject[_i].investmentId,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }

      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //resres.investmentId === "" + args.investmentID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          if (requestBatch[index].operation.toUpperCase() == "BurgissHoldingCalcVALUATIONDATE".toUpperCase()) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcEndDate != null || resout.calcEndDate != ""
                ? new Date(resout.calcEndDate).toLocaleDateString()
                : "";
          } else {
            out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          }
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " -" + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchPooledbenchmarkFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request, index): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          investmentId: responseObject[_i].investmentId,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //resres.investmentId === "" + args.investmentID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          if (requestBatch[index].operation.toUpperCase() == "BurgissVALUATIONDATE".toUpperCase()) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcEndDate != null || resout.calcEndDate != ""
                ? new Date(resout.calcEndDate).toLocaleDateString()
                : "";
          } else {
            out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          }
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchPooledbenchmarkphase2FromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request, index): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          investmentId: responseObject[_i].investmentId,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }

      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //resres.investmentId === "" + args.investmentID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          if (requestBatch[index].operation.toUpperCase() == "BurgissVALUATIONDATE".toUpperCase()) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcEndDate != null || resout.calcEndDate != ""
                ? new Date(resout.calcEndDate).toLocaleDateString()
                : "";
          } else {
            out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          }
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchUAMeasuresFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          peerGroupId: responseObject[_i].peerGroupID,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //String(resres.peerGroupId) === "" + args.peergroupID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchMeasuresFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request, index): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1" && responseObject[_i].exceptionMessage != "Success"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          investmentId: responseObject[_i].investmentId,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //resres.investmentId === "" + args.investmentID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          if (requestBatch[index].operation.toUpperCase() == "BurgissVALUATIONDATE".toUpperCase()) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcEndDate != null || resout.calcEndDate != ""
                ? new Date(resout.calcEndDate).toLocaleDateString()
                : "";
          } else {
            out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          }
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
        // }
      }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchPercentileRankFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request, index): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;
      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          investmentId: responseObject[_i].investmentID,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            resres.investmentId === "" + args.investmentID + "" &&
            resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          if (requestBatch[index].operation.toUpperCase() == "BurgissVALUATIONDATE".toUpperCase()) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcEndDate != null || resout.calcEndDate != ""
                ? new Date(resout.calcEndDate).toLocaleDateString()
                : "";
          } else {
            out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          }
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
        // }
      }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchPooledbenchmarkphase2UnivFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          universe: responseObject[_i].universe,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //String(resres.universe) === "" + args.universe + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchProfilerFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          peerGroupId: responseObject[_i].peerGroupID,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //String(resres.peerGroupId) === "" + args.peergroupID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchMinAndMaxDateFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request, index): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;
      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          investmentId: responseObject[_i].investmentId,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            resres.portId == args.portfolioID &&
            resres.measure.toUpperCase() == args.measure.toUpperCase() &&
            args.measure != null
          //resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          if (
            resout.measure.toUpperCase().includes("MAX") &&
            requestBatch[index].operation.toUpperCase().includes("MAX")
          ) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcEndDate != null || resout.calcEndDate != ""
                ? new Date(resout.calcEndDate).toLocaleDateString()
                : "";
          } else if (
            resout.measure.toUpperCase().includes("MIN") &&
            requestBatch[index].operation.toUpperCase().includes("MIN")
          ) {
            out =
              responseString == undefined
                ? "#NOTFOUND - No investments found"
                : resout.calcStartDate != null || resout.calcStartDate != ""
                ? new Date(resout.calcStartDate).toLocaleDateString()
                : "";
          } else {
            out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          }
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
        // }
      }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchPeerGroupCapitalizationFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          peerGroupId: responseObject[_i].peerGroupID,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //String(resres.peerGroupId) === "" + args.peergroupID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchTargetSizeFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseObject = resresult;
      let out: any;
      const responseMeasuresArray: ResponseMeasures[] = [];
      let resout: any;

      // for (let bthcnt = 0; bthcnt <= requestBatch.length - 1; bthcnt++) {
      for (let _i = 0; _i < responseObject.length; _i++) {
        const responseresult: ResponseMeasures = {
          fundId: responseObject[_i].fundId,
          measureValue:
            responseObject[_i].measureValue == "-1"
              ? responseObject[_i].exceptionMessage
              : responseObject[_i].measureValue,
          portfolioID: responseObject[_i].portfolioID,
          measure: responseObject[_i].measure,
          idType: responseObject[_i].idType,
          portId: responseObject[_i].portfolioID,
          assetId: "",
          calcStartDate: responseObject[_i].calcStartDate,
          calcEndDate: responseObject[_i].calcEndDate,
          statusCode: responseObject[_i].statusCode,
          message: responseObject[_i].message,
          exceptionMessage: responseObject[_i].exceptionMessage,
          percentRank: responseObject[_i].percentRank,
          alias: responseObject[_i].alias,
        };
        responseMeasuresArray.push(responseresult);
      }
      const responseString = JSON.stringify(
        responseMeasuresArray.find(
          (resres) =>
            //String(resres.portfolioID) === "" + args.portfolioID + "" &&
            //resres.measure.toUpperCase() === "" + args.measure.toUpperCase() + "" &&
            //args.measure != null &&
            resres.alias === args.alias
        )
      );
      resout = responseString == undefined ? (resout = 0) : (resout = JSON.parse(responseString));
      switch (resout.statusCode) {
        case Number(ErrorCodes.Success):
          out = responseString == undefined ? "#NOTFOUND - No investments found" : resout.measureValue;
          break;
        case Number(ErrorCodes.InternalServerError):
        case Number(ErrorCodes.UnAuthorized):
        case Number(ErrorCodes.NotFound):
          out =
            responseString == undefined
              ? "#NOTFOUND - No investments found"
              : resout.message + " - " + resout.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
          break;
      }
      // }
      return {
        result: out,
      };
    } catch (error) {
      return {
        error: `Operation failed: ${operation}`,
      };
    }
  });
}
async function _fetchPooledbenchmarkUnivFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);

  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseMeasuresArray: ResponseMeasures[] = resresult.map((response: any) => ({
        fundId: response.fundId,
        measureValue: response.measureValue === "-1" ? response.exceptionMessage : response.measureValue,
        universe: response.universe,
        measure: response.measure,
        idType: response.idType,
        portId: response.portfolioID,
        assetId: "",
        calcStartDate: response.calcStartDate,
        calcEndDate: response.calcEndDate,
        statusCode: response.statusCode,
        message: response.message,
        exceptionMessage: response.exceptionMessage,
        percentRank: response.percentRank,
        alias: response.alias,
      }));

      const foundMeasure = responseMeasuresArray.find(
        (res) =>
          //String(res.universe) === String(args.universe) &&
          //res.measure.toUpperCase() === args.measure.toUpperCase() &&
          //args.measure != null &&
          res.alias === args.alias
      );

      if (!foundMeasure) {
        return { result: "#NOTFOUND - No investments found" };
      }

      let out: string;
      switch (foundMeasure.statusCode) {
        case ErrorCodes.Success:
          out = foundMeasure.measureValue;
          break;
        case ErrorCodes.InternalServerError:
        case ErrorCodes.UnAuthorized:
        case ErrorCodes.NotFound:
          out = foundMeasure.message + " - " + foundMeasure.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
      }

      return { result: out };
    } catch (error) {
      return { error: `Operation failed: ${operation}` };
    }
  });
}
async function _fetchBenchmarkRankUniverseFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);
  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseMeasuresArray: ResponseMeasures[] = resresult.map((response: any) => ({
        fundId: response.fundId,
        measureValue: response.measureValue === "-1" ? response.exceptionMessage : response.measureValue,
        investmentId: response.investmentId,
        measure: response.measure,
        idType: response.idType,
        portId: response.portfolioID,
        assetId: "",
        calcStartDate: response.calcStartDate,
        calcEndDate: response.calcEndDate,
        statusCode: response.statusCode,
        message: response.message,
        exceptionMessage: response.exceptionMessage,
        percentRank: response.percentRank,
        universe: response.universe,
        commitment: response.commitment,
        weight: response.weight,
        alias: response.alias,
      }));

      const foundMeasure = responseMeasuresArray.find(
        (res) =>
          //res.universe === String(args.universe) &&
          //(res.commitment === String(args.commitment) || res.weight === String(args.weight)) &&
          //res.measure.toUpperCase() === args.measure.toUpperCase() &&
          //args.measure != null &&
          res.alias === args.alias
      );

      if (!foundMeasure) {
        return { result: "#NOTFOUND - No investments found" };
      }

      let out: string;
      switch (foundMeasure.statusCode) {
        case ErrorCodes.Success:
          out = foundMeasure.measureValue;
          break;
        case ErrorCodes.InternalServerError:
        case ErrorCodes.UnAuthorized:
        case ErrorCodes.NotFound:
          out = foundMeasure.message + " - " + foundMeasure.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
      }

      return { result: out };
    } catch (error) {
      return { error: `Operation failed: ${operation}` };
    }
  });
}
async function _fetchPercentRankMeasuresFromRemoteService(
  requestBatch: Array<{ operation: string; args: any[] }>,
  resresult: any
): Promise<ServerResponse[]> {
  await pause(1000);
  return requestBatch.map((request): ServerResponse => {
    const args: any = request.args;
    const operation: any = request.operation;
    try {
      const responseMeasuresArray: ResponseMeasures[] = resresult.map((response: any) => ({
        fundId: response.fundId,
        measureValue: response.measureValue === "-1" ? response.exceptionMessage : response.measureValue,
        peerGroupId: response.peerGroupID,
        measure: response.measure,
        idType: response.idType,
        portId: response.portfolioID,
        assetId: "",
        calcStartDate: response.calcStartDate,
        calcEndDate: response.calcEndDate,
        statusCode: response.statusCode,
        message: response.message,
        exceptionMessage: response.exceptionMessage,
        percentRank: response.percentRank,
        alias: response.alias,
      }));

      const foundMeasure = responseMeasuresArray.find(
        (res) =>
          //String(res.peerGroupId) === String(args.peergroupID) &&
          //res.measure.toUpperCase() === args.measure.toUpperCase() &&
          //args.measure != null &&
          res.alias === args.alias
      );

      if (!foundMeasure) {
        return { result: "#NOTFOUND - No investments found" };
      }

      let out: string;
      switch (foundMeasure.statusCode) {
        case ErrorCodes.Success:
          out = foundMeasure.measureValue;
          break;
        case ErrorCodes.InternalServerError:
        case ErrorCodes.UnAuthorized:
        case ErrorCodes.NotFound:
          out = foundMeasure.message + " - " + foundMeasure.exceptionMessage;
          break;
        default:
          out = "#NOTFOUND - No investments found";
      }
      return { result: out };
    } catch (error) {
      return { error: `Operation failed: ${operation}` };
    }
  });
}

function convertType(attributeValue: any, attributeType: any) {
  if (attributeType == "string") {
    return String(attributeValue);
  } else if (attributeType == "date") {
    return new Date(attributeValue).toISOString().split("T")[0];
  } else if (attributeType == "datetime") {
    return new Date(attributeValue);
  } else if (attributeType == "double" || attributeType == "decimal") {
    return new Number(attributeValue);
  } else {
    return attributeValue;
  }
}
const functionGroupMap = {
  [FunctionGroup.BenchmarkRank]: _fetchBenchmarkRankFromRemoteService,
  [FunctionGroup.Getattributes]: _fetchAttributeFromRemoteService,
  [FunctionGroup.Cfar]: _fetchCfarFromRemoteService,
  [FunctionGroup.Holdings]: _fetchHoldingsFromRemoteService,
  [FunctionGroup.Pooledbenchmark]: _fetchPooledbenchmarkFromRemoteService,
  [FunctionGroup.Pooledbenchmarkphase2]: _fetchPooledbenchmarkphase2FromRemoteService,
  [FunctionGroup.UAMeasures]: _fetchUAMeasuresFromRemoteService,
  [FunctionGroup.Measures]: _fetchMeasuresFromRemoteService,
  [FunctionGroup.Profiler]: _fetchProfilerFromRemoteService,
  [FunctionGroup.PercentileRank]: _fetchPercentileRankFromRemoteService,
  [FunctionGroup.BenchmarkRankUniverse]: _fetchBenchmarkRankUniverseFromRemoteService,
  [FunctionGroup.Minandmaxdate]: _fetchMinAndMaxDateFromRemoteService,
  [FunctionGroup.PeerGroupCapitalization]: _fetchPeerGroupCapitalizationFromRemoteService,
  [FunctionGroup.TargetSize]: _fetchTargetSizeFromRemoteService,
  [FunctionGroup.Pooledbenchmarkphase2Univ]: _fetchPooledbenchmarkphase2UnivFromRemoteService,
  [FunctionGroup.PooledbenchmarkUniv]: _fetchPooledbenchmarkUnivFromRemoteService,
  [FunctionGroup.PercentRankMeasures]: _fetchPercentRankMeasuresFromRemoteService,
};

export function _makeRemoteRequest(token: any, profileId: any) {
  // Copy the shared batch and allow the building of a new batch while you are waiting for a response.
  // Note the use of "splice" rather than "slice", which will modify the original _batch array
  // to empty it out.
  setIsInvestBatchedRequestScheduled(false);
  const batchInv = _batchInv.splice(0, _batchInv.length);
  const batchSize = 500;
  const len = Math.ceil(batchInv.length / batchSize);
  (async () => {
    const sheetProps = await activeSheetProps();
    const sheetId = sheetProps.id;
    calculate(len, 0, sheetId);
    for (let i = 1; i <= len; i++) {
      const batchArray: any = createBatchingBasedOnApiGroup(batchInv.splice(0, batchSize));
      await Promise.all(
        batchArray.map(async (batch) => {
          const apiUrl = batch[0].apiUrl;
          const functionGroup = batch[0].functionGroup;
          measuresArray = [];
          peerGroupArray = [];

          // Build a simpler request batch that only contains the arguments for each invocation.
          const requestBatch = batch.map((item) => {
            const measures = item.args;
            if (functionGroup === FunctionGroup.PercentileRank) {
              peerGroupArray.push(measures);
            } else {
              measuresArray.push(measures);
            }
            return { operation: item.operation, args: measures };
          });

          const parameters: Param = {
            measures: measuresArray,
            peerGroups: peerGroupArray,
            dpsid_data_area_type: null,
            dpsid_all_portfolios: false,
            dpsid_portfolio_id: "-1", //localStorage.getItem('portfolioId').toString(),
            dpsid_selection_set_id: null,
            userGUID: null,
            includeCommitment: false,
            initialLoad: false,
            correlationId: "34bc67f8-568d-42c7-add8-b335d3b45ea4",
            culture: {
              currencyDecimalSeparator: ".",
              currencyGroupSeparator: ",",
              name: "en-US",
              shortDatePattern: "M/d/yyyy",
            },
            excelFileName: "Book2 - Excel",
            excelSheetName: "Sheet1", //validations.getActiveWorksheet(),
            jobTaskId: "adea50c2-7232-4401-99b1-de0394e97955",
            sourceVersion:
              "Microsoft.O365ProPlusRetail|x64|16.0.17425.20236|16.0.17425.20236|v1.32.1|Book2 - Excel|Sheet1",
          };
          const jsonRequest: Root = { parameters };
          try {
            const response = await webRequest(jsonRequest, apiUrl, token, profileId);
            const fetchService = functionGroupMap[functionGroup];

            if (fetchService) {
              const responseBatch = await fetchService(requestBatch, response);
              responseBatch.forEach((res, index) => {
                if (res.error) {
                  batch[index].reject(new Error(res.error));
                } else {
                  batch[index].resolve(res.result);
                }
              });
            } else {
              console.error("Unknown function group:", functionGroup);
            }
          } catch (error) {
            console.error("Request failed:", error);
          }
        })
      );
      await calculate(len, i, sheetId);
    }
  })();
}
const calculate = async (batchCount, completedBatches, id) => {
  const option = await getActiveSheetStatebyId(id);
  if (!option.sheetState) {
    setActiveSheetState({
      ...option,
      sheetState: option.sheetState,
      BatchCount: batchCount,
      CompletedBatchCount: completedBatches,
    });
  }
};
